import React from 'react';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import Breadcrumb, {BreadcrumbGroup} from '@amzn/meridian/breadcrumb';
import Responsive from '@amzn/meridian/responsive'
import {ContainerDetailsModel} from "src/components/common/container-details/ContainerDetailsModel";
import {responsiveProps} from "src/constants/responsiveProps";
import * as AppRoutes from 'src/routing/constants/routes';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import {PrintIcons} from "src/constants/general-media";
import UILoader from "src/components/common/loader/UILoaderContainer";
import StatusAlert from "src/components/common/status-alert/StatusAlertContainer";
import ContainerLabelDetails from "src/components/pages/print-page/ContainerLabelDetails";
import './Print.scss';
import {
    buildPrintContainerLabelDetailsInput,
    PrintContainerLabelDetailsInput, PrintContainerLabelDetailsOutput
} from "src/models/PrintContainerLabelDetails";
import SearchInput from 'src/components/common/search-input/SearchInput';
import {
    buildGetContainerDetailsInput,
    GetContainerDetailsInput,
    GetContainerMode
} from "src/models/GetContainerDetails";

export interface PrintProps {
    containerLabelDetails?: ContainerDetailsModel;
    warehouseId: string,
    associate: string, 
    locale: string
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => void;
    resetContainerState: () => void;
    printContainerLabel: (printContainerLabelDetailsInput: PrintContainerLabelDetailsInput) => PrintContainerLabelDetailsOutput;
}

class Print extends React.Component<PrintProps> {

    private onSearchSubmit = async (containerId: string) => {
        await this.props.fetchContainerDetails(buildGetContainerDetailsInput(containerId,
            this.props.warehouseId, this.props.associate, this.props.locale, GetContainerMode.PRINT));
    };

    private onSearchSubmitPrint = async (searchFieldValuePrint: string) => {
        if (this.props.containerLabelDetails) {
            await this.props.printContainerLabel(buildPrintContainerLabelDetailsInput(this.props.containerLabelDetails.containerId, searchFieldValuePrint,
                this.props.warehouseId, this.props.associate, this.props.locale
            ));
        }
    };

    public render() {
        return (
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <Column className="print">
                        <BreadcrumbGroup>
                            <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                            <Breadcrumb>{AppStrings.PRINT}</Breadcrumb>
                        </BreadcrumbGroup>

                        {/* first page of print renders print icon and text */}
                        {!this.props.containerLabelDetails &&
                            <Column alignmentHorizontal="center">
                                <img src={PrintIcons.PRINTER_ICON} alt="Print Icon" className="print-icon" />
                                <Text type={props.titleSize}>{AppStrings.PRINT_CENTER_TEXT}</Text>
                            </Column>
                        }

                        {/* first page of print renders search field for entering tote, pallet or stacking area */}
                        {!this.props.containerLabelDetails &&
                            <SearchInput
                                searchFieldLabel={AppStrings.PRINT_SEARCHFIELD_LABEL}
                                searchFieldPlaceholder={AppStrings.PRINT_SEARCHFIELD_PLACEHOLDER}
                                renderSearchButton={true}
                                onSubmit={this.onSearchSubmit}
                            />
                        }

                        <UILoader/>
                        <StatusAlert/>

                        {/* second page of print renders search field for entering printer id */}
                        {this.props.containerLabelDetails &&
                            <SearchInput
                                searchFieldLabel={AppStrings.PRINTER_SEARCHFIELD_LABEL}
                                searchFieldPlaceholder={AppStrings.PRINTER_SEARCHFIELD_PLACEHOLDER}
                                renderSearchButton={true}
                                onSubmit={this.onSearchSubmitPrint}
                            />
                        }
                        {/* second page of print renders container label details for valid container ID */}
                        {this.props.containerLabelDetails &&
                            <ContainerLabelDetails containerLabelDetails={this.props.containerLabelDetails} />
                        }
                    </Column>
                )}
            </Responsive>
        );
    }
    componentWillUnmount() {
        this.props.resetContainerState();
    }
}

export default Print;
